module.exports = {
  defaultTitle: 'John Doe',
  logo: '',
  author: 'John Doe',
  url: 'https://codegabriel.com',
  legalName: 'John Doe',
  defaultDescription: 'I’m John and I’m a Backend & Devops engineer!',
  socialLinks: {
  },
  googleAnalyticsID: 'UA-130691261-3',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    facebook: 'appId',
    twitter: '@smakosh',
  },
  address: {
    city: 'City',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2021',
};
